import type { Lesson } from '../types';

/**
 * Cover image for public lesson cards: lesson-specific image, else linked program image (API-enriched).
 */
export function getLessonPublicCoverImageUrl(
  lesson: Pick<Lesson, 'imageUrl' | 'programImageUrl'>
): string | undefined {
  return lesson.imageUrl ?? lesson.programImageUrl ?? undefined;
}
